/* istanbul ignore file */
// This file was generated by figma/utils.mjs
import React, { FunctionComponent } from 'react'

export const CaretLeft: FunctionComponent = (): JSX.Element => (
  <React.Fragment>
    <path d='M12.4143 23L1.41431 12L12.4143 1' stroke='currentColor' fill='transparent' strokeWidth='2' strokeMiterlimit='10' strokeLinecap='round' />
  </React.Fragment>
)
